<div class="d-flex flex-column w-100">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <!-- INFO Headline -->
      <div class="d-flex flex-column mt-5">
        <p class="fw-normal" style="font-size: 56px; line-height: normal;">Complete your password reset</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <mat-stepper #stepper>
        <!-- INFO Verify code -->
        <mat-step [editable]="false">
          <div class="d-flex flex-column w-100">
            <div class="d-flex mx-auto p-2e">
              <p class="mb-0 text-left mat-headline-5 fw-bnormal">Enter the password reset code</p>
            </div>

            <!-- INFO Code blocks -->
            <div class="d-flex w-100 my-4e justify-content-between">
              <input #otpBoxes *ngFor="let item of [1,2,3,4,5,6]; index as i;" [formControl]="getControlAt(i)"
                     class="w-48px h-48px mb-0 p-2 mat-h1  text-center bg-light border-1 border-primary rounded-3" type="text"
                     minlength="1" (keyup)="onKeyUp(i, $event)">
            </div>

            <button mat-flat-button class="mt-1 px-3 py-4 fw-bold rounded-3e" color="primary"
                    (click)="resetVerificationForm(stepper)">
              <span class="my-auto mat-body-1 fw-bold">Verify</span>
            </button>

            <p class="mx-auto mt-4 mb-0 p-2e mat-body-1">
              Can't find it?
              <a mat-button [routerLink]="['/', 'reset', 'password']" [queryParams]="queryParams" class="ms-1 text-primary">
                <span class="my-auto mat-body">Try again</span>
              </a>
            </p>
          </div>
        </mat-step>

        <!-- INFO Change Password -->
        <mat-step [editable]="false">
          <div class="d-flex flex-column w-100">
            <div class="d-flex mx-auto p-2e">
              <p class="mb-0 text-left mat-headline-5 fw-normal">Reset password</p>
            </div>

            <form [formGroup]="formGroup" class="d-flex flex-column w-100 mt-4">
              <!-- INFO -->
              <span *ngIf="formGroup.errors" class="text-danger mb-3">{{ formGroup.errors['passwordMisMatch'] }}</span>

              <!-- INFO Password -->
              <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" placeholder="Password" [type]="hide ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                  <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' :
                    'visibility'}}</mat-icon>
                </button>
              </mat-form-field>

              <!-- INFO Confirm Password -->
              <mat-form-field appearance="outline">
                <mat-label>Confirm Password</mat-label>
                <input matInput formControlName="confirmPassword" placeholder="Confirm Password" [type]="hideConfirm ? 'password' : 'text'">
                <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm"
                        [attr.aria-label]="'Hide confirm password'" [attr.aria-pressed]="hideConfirm">
                  <mat-icon fontSet="material-symbols-outlined">{{hideConfirm ? 'visibility_off' :
                    'visibility'}}</mat-icon>
                </button>
                <mat-hint>minimum 8 characters, you are advised to choose a strong password</mat-hint>
              </mat-form-field>

              <button mat-flat-button class="mt-4 px-3 py-4 fw-bold rounded-3e" color="primary" [disabled]="inProgress || formGroup.invalid" (click)="resetPassword()">
                <span class="my-auto mat-body-1 fw-bold">Submit</span>
              </button>

              <button mat-button class="mt-3e mx-auto mat-body-1 rounded-3e text-primary" (click)="resendPasswordReset(stepper)">
                <span class="my-auto mat-body">Resend OTP</span>
              </button>
            </form>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>
